(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-top-description"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('collapsible-description')) {
    customElements.define(
      'collapsible-description',
      class extends HTMLElement {
        connectedCallback() {
          this.content = this.querySelector('.collection-top-description__content');
          this.button = this.querySelector('.collection-top-description__toggle');
          if (!this.content || !this.button) return;

          this.button.addEventListener('click', () => this.toggle());
          this.resizeObserver = new ResizeObserver(() => this.update());
          this.resizeObserver.observe(this);
          this.update();
        }

        disconnectedCallback() {
          this.resizeObserver?.disconnect();
        }

        get expanded() {
          return this.button.getAttribute('aria-expanded') === 'true';
        }

        update() {
          if (this.expanded) return;
          // Measure while collapsed to see if the text is actually clipped
          this.content.dataset.collapsed = 'true';
          const overflowing = this.content.scrollHeight > this.content.clientHeight + 1;
          this.button.hidden = !overflowing;
          if (!overflowing) delete this.content.dataset.collapsed;
        }

        toggle() {
          const expand = !this.expanded;
          this.button.setAttribute('aria-expanded', String(expand));
          if (expand) {
            delete this.content.dataset.collapsed;
          } else {
            this.content.dataset.collapsed = 'true';
          }
          this.button.textContent = expand ? this.dataset.showLess : this.dataset.readMore;
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
